export const growth = {
  id: "growth",
  name: "Growth",

  scene: {
    backgroundImage: null,
    baseColor: "#060e08",
    radialGlow: "radial-gradient(ellipse at 50% 40%, rgba(40, 180, 80, 0.08) 0%, transparent 60%)",
    overlayTint: "rgba(4, 10, 6, 0.34)",
    vignette: 0.56,
    parallaxStrength: 0.3,
    particleType: "none",
  },

  glass: {
    bg: "rgba(8, 18, 12, 0.55)",
    blur: 14,
    border: "rgba(40, 180, 80, 0.18)",
    radius: 14,
  },

  glow: {
    edgeColor: "rgba(40, 180, 80, 0.35)",
    edgeStrength: 0.35,
    heroBoost: 0.5,
  },

  accent: {
    primary: "#28b450",
    secondary: "#1a7a38",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "bot",
    orbGlow: "rgba(40,180,80,0.32)",
  },

  tokens: {
    "--tl-bg-0": "#060e08",
    "--tl-bg-1": "#040a06",
    "--tl-bg-2": "#020604",
    "--tl-text-0": "#d8f0e0",
    "--tl-text-1": "#b0d4b8",
    "--tl-text-muted": "#78a088",
    "--tl-accent-0": "#28b450",
    "--tl-accent-1": "#1a7a38",
    "--tl-glass-bg": "rgba(8, 18, 12, 0.55)",
    "--tl-glass-border": "rgba(40, 180, 80, 0.18)",
    "--tl-glass-blur": "14px",
    "--tl-glass-shadow": "0 10px 30px rgba(0,0,0,0.45)",
    "--tl-glass-glow-color": "rgba(40,180,80,0.26)",
    "--tl-glow-edge-color": "rgba(40, 180, 80, 0.35)",
    "--tl-glow-edge-strength": "0.35",
    "--tl-glow-hero-boost": "0.5",
    "--tl-radius": "14px",
    "--tl-molten-wordmark-gradient": "none",
  },
};
